import classNames from 'classnames'
import * as React from 'react'

import './Col.scss'
import './Grid.scss'

function getPropsFromArray(prefix: string, arr?: Array<number | boolean>) {
  if (arr) {
    return [
      arr.length > 0 ? `mobile-${prefix}-${arr[0]}` : null,
      arr.length > 1 ? `tablet-${prefix}-${arr[1]}` : null,
      arr.length > 2 ? `desktop-${prefix}-${arr[2]}` : null,
      arr.length > 3 ? `cinema-${prefix}-${arr[3]}` : null,
    ]
  }
  return []
}

export enum GridGap {
  zero = '',
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl',
}

interface GridProps {
  className?: string
  nrCols?: number[]
  colGap?: GridGap[]
  rowGap?: GridGap[]
  slider?: boolean
  minContent?: boolean
  children?: React.ReactNode | undefined
}

const Grid: React.FC<GridProps> = props => {
  const cols = getPropsFromArray('cols', props.nrCols)
  const gridClasses = classNames(
    'srprs-grid',
    props.className ? props.className : null,
    ...cols,
    props.colGap ? `grid-col-gap-${props.colGap}` : null,
    props.rowGap
      ? `grid-row-gap-${props.rowGap}`
      : `grid-row-gap-${props.colGap}`,
    props.slider ? `slider` : null,
    props.minContent ? `min-content` : null,
  )

  return <div className={gridClasses}>{props.children}</div>
}

interface ColProps {
  className?: string
  justify?: 'left' | 'center' | 'right'
  align?: 'top' | 'center' | 'bottom'
  span?: number[]
  display?: boolean[]
  children?: React.ReactNode | undefined
}

const Col: React.FC<ColProps> = props => {
  const colSpan = getPropsFromArray('col-span', props.span)
  const display = getPropsFromArray('display', props.display)
  const colClasses = classNames(
    'srprs-col',
    props.className ? props.className : false,
    props.justify ? `justify-self-${props.justify}` : false,
    props.align ? `align-self-${props.align}` : false,
    ...colSpan,
    ...display,
  )

  return <div className={colClasses}>{props.children}</div>
}

export { Col, Grid }
